<template lang="pug">
  .existing-subscription
    .xs-12.xs-f-xsmall.max-at-tweak
      p.upper Upcoming Subscription:
      p
        span.bold {{ subscription.product.name }}
        span.xs-pl-50m(v-if="subUrl")
          | (
          a(:href="subUrl").underline Manage
          | )

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "PdpExistingSubscription",

  computed: {
    ...mapState('pdp', ['subscription']),

    subUrl() {
      let url;
      if (this.subscription.id) {
        url = `/dashboard/subscriptions/edit-subscription/${this.subscription.id}`;
      }

      return url;
    }
  }
}
</script>

<style scoped lang="stylus">

</style>